export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M10 5v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V5z\"/>"
};